<p-toast [baseZIndex]="99999"></p-toast>
<p-toast [baseZIndex]="99999" styleClass="custom-toast" position="bottom-center" key="add-stop">
	<ng-template let-message pTemplate="message">
		<div class="toast-content">
			<i class="icon-info"></i>
			<p>{{ message.summary }}</p>
		</div>
	</ng-template>
</p-toast>
